import React from "react";
import PropTypes from "prop-types";
import { LINKS } from "@constants";
import { Button } from "../../../components/shared/actions";
import { BannerContents } from "../../../components/shared/layout";
import imagensPrevidencia from "@asserts/images/previdencia/index";
import GuiaButton from "../../../components/shared/actions/GuiaButton";
import "../../../components/shared/actions/GuiaButton.css";
import GenericBanner from "../../../components/blocosCustomizados/GenericBanner";

export const BannerVida = (props) => {
  const { images } = props;

  return (
    <BannerContents {...props}>
      <BannerContents.Banner
        backgroundImage={images.bannerVida}
        group={["voce", "coberturas-assistencias", "resultado-sorteios"]}
        className="text-white"
      >
        <h3 className="d-md-inline-block">Seguro de vida</h3>
        <p className="text-body-md">
          Clientes CAIXA agora podem comprar o Seguro de Vida 100% online.
        </p>
        <p className="text-body-md">
          Pague no débito em conta Caixa e aproveite!
        </p>
        <Button
          className="text-center cvp-action-comprar"
          blank
          secondary
          href={LINKS.autoCompraVida}
          style={{ fontWeight: "bold" }}
        >
          Compre agora
        </Button>
      </BannerContents.Banner>
      <BannerContents.Banner
        backgroundImage={images.bannerBemEstarCampanha}
        group={["voce", "coberturas-assistencias", "resultado-sorteios"]}
        className="text-white banner-seguro-acidentes"
      >
        <h3 className="d-md-inline-block">SEGURO ACIDENTES PESSOAIS</h3>
        <div className="box-text">
          {" "}
          <p className="text-body-md">
            GARANTA A PROTEÇÃO DA SUA FAMÍLIA EM CASO DE IMPREVISTOS.
          </p>
        </div>
        <div className="box-value">
          <p className="topValue">A PARTIR DE</p>
          <h3 className="d-md-inline-block">R$ 0,55</h3>
          <p className="subValue">POR DIA.</p>
        </div>
        <Button
          className="text-center cvp-action-comprar button"
          blank
          secondary
          href={LINKS.campanhaBemEstar}
          style={{ fontWeight: "bold" }}
        >
          Contrate agora
        </Button>
      </BannerContents.Banner>
      <GenericBanner
        image={imagensPrevidencia.bannerAssistenciaProtecao}
        text={
          <>
            <div className="margin-top-ajustada">
              <h4 style={{ fontSize: "1.6rem", color: "#F39200" }}>
                ASSISTÊNCIAS QUE VÃO
                <br /> ALÉM DA PROTEÇÃO
              </h4>
              <p>
                Com os nossos Seguros de Vida e planos de Previdência, você
                conta com assistências exclusivas que facilitam seu dia a dia e
                garantem tranquilidade nos momentos em que mais precisa.
              </p>
              <h4>Conheça os serviços disponíveis.</h4>
            </div>

            <div style={{ marginTop: "32px" }}>
              <GuiaButton href={LINKS.guiaAssistencias2025}>
                BAIXE O GUIA
              </GuiaButton>
            </div>
          </>
        }
        textClassName="text-assistencias"
      />
    </BannerContents>
  );
};

BannerVida.defaultProps = { images: {} };

BannerVida.propTypes = {
  images: PropTypes.objectOf(Object)
};

export default BannerVida;
